@if (safeEmbedUrl) {
  <div class="video-frame">
    <div class="overlay" [class.draggable]="draggable"></div>

    <iframe
      [src]="safeEmbedUrl | gbSafe: 'resourceUrl'"
      title="Video"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
} @else {
  <gb-presenter-widget-placeholder>
    <h1 translate="PRESENTER.WIDGET_TYPE.VIDEO"></h1>
    <span translate="PRESENTER.NO_EMBED_URL"></span>
  </gb-presenter-widget-placeholder>
}
